/**
 * Animation für Wechsel der Seiten.
 * @class animation_pageAnimation
 * @memberOf v3sWbtPlayerApp:animation
 */
angular.module('v3sWbtPlayerApp').animation('.pageAnimation', ["v3sNavigationService","$rootScope", function (v3sNavigationService, $rootScope) {
    /**
     * Wird aufgerufen, wenn die Animation zu ende ist
     * @param {function} done
     */

    return {
        enter: function (element, done) {
            TweenLite.set(element, { css: { transformPerspective: 5000, position: "absolute" } });
            switch (v3sNavigationService.getLastDirection()) {
                case "next":
                    TweenMax.from(element, 0.5, {
                        xPercent: "100%", onComplete: function(){
                            done();
                            $rootScope.$broadcast("v3sPageEnterAnimationCompleted");
                        }, clearProps: "position"
                    });
                    break;
                case "previous":
                    TweenMax.from(element, 0.5, {
                        xPercent: "-100%", onComplete: function(){
                            done();
                        $rootScope.$broadcast("v3sPageEnterAnimationCompleted");
                        }, clearProps: "position"
                    });
                    break;
                default:
                    TweenMax.from(element, 0.3, {
                        alpha: 0, scaleX: 0, scaleY: 1, delay: 0.3, onComplete: function(){
                            done();
                            $rootScope.$broadcast("v3sPageEnterAnimationCompleted");
                        }, clearProps: "position"
                        });
            }
            v3sNavigationService.resetLastDirection();
        },
        leave: function (element, done) {
            TweenMax.to(element, 0.3, {
                alpha: 0, scaleX: 0, scaleY: 1, onComplete: function(){
                    done();
                    $rootScope.$broadcast("v3sPageLeaveAnimationCompleted");
                }
                });           
        }
    };
}]);